module.exports = __webpack_public_path__ + "assets/img/icon01.de38cecb.png";